import { Badge } from 'reactstrap';
import { ModelUnitStatus } from '../enums/ModelUnitEnum';

interface Props {
  status: ModelUnitStatus;
  className?: string;
}

const statusModelUnitConfig = {
  created: {
    label: 'Creada',
    color: 'dark',
  },
  pre_booked: {
    label: 'Pre-reservada',
    color: 'info',
  },
  available: {
    label: 'Disponible',
    color: 'success',
  },
  assigned: {
    label: 'Asignada',
    color: 'info',
  },
  taken: {
    label: 'Pagada',
    color: 'success',
  },
  disabled: {
    label: 'Desactivada',
    color: 'danger',
  },
  sold_external: {
    label: 'Vendido fuera',
    color: 'warning',
  },
  on_deed: {
    label: 'En firma',
    color: 'default',
  },
  signing_promise: {
    label: 'Firma de promesa',
    color: 'default',
  },
  na: {
    label: 'N/A',
    color: 'secondary',
  },
};

const ModelUnitStatusBadge = ({ status, className }: Props) => {
  let config = statusModelUnitConfig[status as ModelUnitStatus];
  if (!config) {
    config = statusModelUnitConfig['na'];
  }
  return (
    <Badge color={config.color} className={className}>
      {config.label}
    </Badge>
  );
};

export { ModelUnitStatusBadge };
